module.exports = __webpack_public_path__ + "static/img/成功@2x.1baf88d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/登录注册/成功@2x.png
// module id = D5mv
// module chunks = 192